import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import useFetchClasses from "../../../hooks/useFetchClasses";
import useFetchSections from "../../../hooks/useFetchSections";
import Select from "react-select";

import { ApiUrl } from "../../../../ApiUrl";

const SelectStudentModal = ({ show, handleClose, onSelectStudent }) => {
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedStudents, setSelectedStudents] = useState([]); // Store selected students

  const [students, setStudents] = useState([]);
  const [studentLoading, setStudentLoading] = useState(false);
  const [studentError, setStudentError] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const {
    classes,
    loading: classLoading,
    error: classError,
  } = useFetchClasses();
  const [studentData, setStudentData] = useState([]);
  const [fullStudentData, setFullStudentData] = useState([]);
  const [filters, setFilters] = useState({
    studentName: "",
    admissionNo: "",
    barcode: "",
    classId: "",
    section: "",
    fatherName: "",
    motherName: "",
    schoolAdmissionNo: "",
  });
  const navigate = useNavigate();

  const {
    sections,
    loading: sectionLoading,
    error: sectionError,
  } = useFetchSections(selectedClass);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  // const handleSearch = async () => {
  //   try {
  //     const academicSessionId = localStorage.getItem("academicSessionId");
  //     if (!academicSessionId) {
  //       console.error("No academic session ID found in local storage");
  //       return;
  //     }

  //     // Construct the search parameters from the filter values
  //     const queryParams = new URLSearchParams({
  //       studentName: filters.studentName || "",
  //       admissionNo: filters.admissionNo || "",
  //       barcode: filters.barcode || "",
  //       schoolAdmissionNo: filters.schoolAdmissionNo || "",
  //       classId: filters.classId || "",
  //       section: filters.sectionId || "",
  //       fatherName: filters.fatherName || "",
  //       motherName: filters.motherName || "",
  //     }).toString();

  //     // Fetch filtered data based on search
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}?${queryParams}`
  //     );

  //     if (!response.ok) {
  //       throw new Error("Error fetching student data");
  //     }

  //     const data = await response.json();
  //     if (data.data) {
  //       setFullStudentData(data.data);
  //       setStudentData(data.data);
  //     } else {
  //       console.warn("No data found for the given filters");
  //     }
  //   } catch (error) {
  //     console.error("Fetch error:", error);
  //   }
  // };

  const handleSearch = async () => {
    try {
      const academicSessionId = localStorage.getItem("academicSessionId");
      if (!academicSessionId) {
        console.error("No academic session ID found in local storage");
        return;
      }

      // Build query params according to new API
      const queryParams = new URLSearchParams({
        academic_year_id: academicSessionId,
        studentId: "", // keep blank if not using studentId
        studentName: filters.studentName || "",
        classId: selectedClass || "", // use selectedClass
        sectionId: selectedSection || "", // use selectedSection
        admissionNo: filters.admissionNo || "",
        barcode: filters.barcode || "",
        fatherName: filters.fatherName || "",
        motherName: filters.motherName || "",
        schoolAdmissionNo: filters.schoolAdmissionNo || "",
      }).toString();

      const response = await fetch(
        `${ApiUrl.apiurl}STUDENT_CLASS/STUDENTCLASSRECORDFILTER/?${queryParams}`
      );

      if (!response.ok) {
        throw new Error("Error fetching student data");
      }

      const data = await response.json();

      if (data.data) {
        setFullStudentData(data.data);
        setStudentData(data.data);
      } else {
        setFullStudentData([]);
        setStudentData([]);
        console.warn("No data found for the given filters");
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const getClassName = (classId) => {
    const classObj = classes.find((cls) => cls.id === classId);
    return classObj ? classObj.classname : "N/A";
  };

  const getSectionName = (sectionId) => {
    const sectionObj = sections.find((sec) => sec.id === sectionId);
    return sectionObj ? sectionObj.sectionname : "N/A";
  };
  // const handleSelectStudent = (selectedStudent) => {
  //   setSelectedStudents((prevSelected) => {
  //     const exists = prevSelected.some(
  //       (s) => s.studentBasicDetails.id === selectedStudent.studentBasicDetails.id
  //     );
  //     if (exists) {
  //       return prevSelected.filter(
  //         (s) =>
  //           s.studentBasicDetails.id !== selectedStudent.studentBasicDetails.id
  //       );
  //     } else {
  //       return [...prevSelected, selectedStudent];
  //     }
  //   });
  // };

  const handleSelectStudent = (selectedStudent) => {
    setSelectedStudents((prevSelected) => {
      const exists = prevSelected.some(
        (s) => s.studentId === selectedStudent.studentId
      );

      if (selectAll) {
        setSelectAll(false);
        return [];
      }

      return exists
        ? prevSelected.filter((s) => s.studentId !== selectedStudent.studentId)
        : [...prevSelected, selectedStudent];
    });
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      setSelectedStudents(studentData); // Select all students
    } else {
      setSelectedStudents([]); // Deselect all students
    }
  };

  const handleClearFilters = () => {
    // Reset all filters and state variables
    setFilters({
      studentName: "",
      admissionNo: "",
      barcode: "",
      classId: "",
      section: "",
      fatherName: "",
      motherName: "",
      schoolAdmissionNo: "",
    });
    setSelectedClass(""); // Clear the selected class
    setSelectedSection(""); // Clear the selected section
    setStudentData(fullStudentData); // Reset the student data to the full list
  };

  // const handleSubmit = () => {
  //   console.log("Selected Students:", selectedStudents);
  //   // You can now use `selectedStudents` to send the data to another component or an API.
  // };

  const handleSubmit = () => {
    navigate("/admin/assign-student-mentor", { state: { selectedStudents } });
    handleClose();
  };

  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onClick={handleClose}></Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card p-0">
                <div className="card-body">
                  <p
                    style={{
                      marginBottom: "0px",
                      textAlign: "center",
                      fontSize: "20px",
                      fontWeight: "700",
                    }}
                  >
                    STUDENT SEARCH
                  </p>
                  <div className="row mb-2">
                    <div
                      className="col-12 d-flex flex-wrap gap-2"
                      style={{ border: "1px solid #ccc" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{ width: "150px" }}
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{ width: "150px" }}
                        onClick={handleClearFilters}
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger me-2"
                        style={{ width: "150px" }}
                        onClick={handleClose}
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary me-2"
                        style={{ width: "150px" }}
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                  {/* Search Fields */}
                  <div className="row mt-3">
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        
                        Student Name
                      </label>
                      <input
                        type="text"
                        name="studentName"
                        value={filters.studentName}
                        onChange={handleInputChange}
                        className=" detail"
                        placeholder="Student Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        {" "}
                        Admission No{" "}
                      </label>
                      <input
                        type="text"
                        name="admissionNo"
                        value={filters.admissionNo}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Admission No"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                      
                        Student Barcode
                      </label>
                      <input
                        type="text"
                        name="barcode"
                        value={filters.barcode}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Student Barcode"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }} // Inline style to set height and padding
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                       
                        Class
                      </label>
                      <Select
                        options={classes.map((cls) => ({
                          label: cls.classname,
                          value: cls.id,
                        }))}
                        onChange={(selectedOption) =>
                          setSelectedClass(selectedOption?.value)
                        }
                        placeholder="Select Class"
                        value={
                          selectedClass
                            ? {
                                label: getClassName(selectedClass),
                                value: selectedClass,
                              }
                            : null
                        }
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        
                        Section
                      </label>
                      <Select
                        options={sections.map((sec) => ({
                          label: sec.sectionname,
                          value: sec.id,
                        }))}
                        onChange={(selectedOption) =>
                          setSelectedSection(selectedOption?.value)
                        }
                        placeholder="Select Section"
                        value={
                          selectedSection
                            ? {
                                label: getSectionName(selectedSection),
                                value: selectedSection,
                              }
                            : null
                        }
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                        Father's Name
                      </label>
                      <input
                        type="text"
                        name="fatherName"
                        value={filters.fatherName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Father's Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                    <div className="col-12 col-md-3 mb-2">
                      <label
                        htmlFor="school-admission-no"
                        className="form-label"
                      >
                       
                        Mother's Name
                      </label>
                      <input
                        type="text"
                        name="motherName"
                        value={filters.motherName}
                        onChange={handleInputChange}
                        className="form-control detail"
                        placeholder="Mother's Name"
                        style={{ height: "38px", padding: "0.375rem 0.75rem" }}
                      />
                    </div>
                  </div>
                  {/* Students Table */}
                  <div className="table-responsive mt-3">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Student Name</th>
                          <th>Admission No</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Father Name</th>
                          <th>Mother Name</th>
                          <th>Student Barcode</th>
                          {/* <th>Actions</th> */}
                          <th>
                            Select
                            <br />
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={selectAll}
                              title="Select All"
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {studentData.map((student, index) => {
                          return (
                            <tr key={index}>
                              <td>{student.studentname}</td>
                              <td>{student.rollno}</td>
                              <td>{student.classname}</td>
                              <td>{student.sectionname}</td>
                              <td>{student.father_name}</td>
                              <td>{student.mother_name}</td>
                              <td>{student.barcode}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  onChange={() => handleSelectStudent(student)}
                                  checked={selectedStudents.some(
                                    (s) => s.studentId === student.studentId,
                                  )}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SelectStudentModal;
